import React from 'react';
import { BasePdfComponent, PdfComponentBorderProperties } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentBorderWidth from './border/PdfTemplateComponentBorderWidth';
import PdfTemplateComponentBorderEnabled from './border/PdfTemplateComponentBorderEnabled';
import PdfTemplateComponentBorderStyle from './border/PdfTemplateComponentBorderStyle';
import PdfTemplateComponentBorderColor from './border/PdfTemplateComponentBorderColor';

export interface PdfComponentWithBorder extends BasePdfComponent {
  border: PdfComponentBorderProperties;
}

export default function PdfTemplateComponentBorder<T>({ component }: { component: PdfComponentWithBorder }) {
  const { updateComponent } = usePdfTemplateContext<T>();

  const updateBorder = (border: Partial<PdfComponentBorderProperties>) => {
    updateComponent(component.id, { border: { ...component.border, ...border } });
  };

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentBorderEnabled component={component} updateBorder={updateBorder} />
      {component.border.enabled && (
        <>
          <PdfTemplateComponentBorderColor component={component} updateBorder={updateBorder} />
          <div className='grid grid-cols-4 gap-2'>
            <div className='col-span-3'>
              <PdfTemplateComponentBorderStyle component={component} updateBorder={updateBorder} />
            </div>
            <div className='col-span-1'>
              <PdfTemplateComponentBorderWidth component={component} updateBorder={updateBorder} />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
